<template>
    <div class="container-outline">
        <div class="register">
            <div class="title">Register</div>
            <div class="top-squence">
                <head-register :dataSquence="{ id: 7, title: 'keuangan' }" />
            </div>
            <div class="content-register">
                <div class="container">
                    <p class="sub-title">Data Kekayaan</p>
                    <form @submit.prevent="registerKYC">
                        <div class="form-group">
                            <label for="">Penghasilan Pertahun *</label>
                            <select v-model="form.salary_code" required>
                                <option value="" selected disabled>Pilih penghasilan pertahun</option>
                                <option v-for="sumber in gajiPerbulan" v-bind:key="sumber.code" :value="sumber.code">{{ sumber.name }}</option>
                            </select>
                        </div>
                        <p class="sub">Daftar Kekayaan</p>
                        <div class="form-group">
                            <label>Lokasi Rumah</label>
                            <input
                                type="text"
                                maxlength="80"
                                class="form-input address"
                                placeholder="Alamat rumah saat ini"
                                v-model="form.wealth_list.home_location"
                                @keyup="form.wealth_list.home_location = form.wealth_list.home_location.replace(/[^a-zA-Z\s]/g, '')"
                            />
                        </div>
                        <div class="form-group">
                            <label>Nilai NJOP</label>
                            <input type="text" class="form-input rupiah" value="Rp" readonly />
                            <input
                                type="text"
                                class="form-input nilai-rupiah"
                                placeholder="Masukkan jumlah (hanya angka)"
                                v-model="form.wealth_list.njop_value"
                                @keyup="form.wealth_list.njop_value = form.wealth_list.njop_value.replace(/[^\d]/g, '')"
                                maxlength="15"
                            />
                        </div>
                        <div class="form-group">
                            <label>Deposit Bank</label>
                            <input type="text" maxlength="50" class="form-input address" placeholder="Nama bank anda" v-model="form.wealth_list.deposit" />
                        </div>
                        <div class="form-group">
                            <label>Jumlah</label>
                            <input type="text" class="form-input rupiah" value="Rp" readonly />
                            <input
                                type="text"
                                class="form-input nilai-rupiah"
                                placeholder="Masukkan jumlah (hanya angka)"
                                v-model="form.wealth_list.total_deposit"
                                @keyup="form.wealth_list.total_deposit = form.wealth_list.total_deposit.replace(/[^\d]/g, '')"
                                maxlength="20"
                            />
                        </div>
                        <div class="form-group">
                            <label>Lainnya</label>
                            <input type="text" maxlength="50" class="form-input address" placeholder="lainnya" v-model="form.wealth_list.other" />
                        </div>

                        <div class="form-group form-checkbox">
                            <input type="checkbox" class="checkbox" required v-model="form.has_confirm_financial" />
                            <label class="label--checkbox">
                                Dengan ini saya setuju atas seluruh data KEUANGAN yang saya isi adalah BENAR dan sesuai dengan
                                <span id="toggle-btn" class="ketentuan">Peraturan</span>
                                yang berlaku
                            </label>
                        </div>

                        <div class="button">
                            <router-link to="/register-datapekerjaan"><button class="btn-scondary">Sebelumnya</button></router-link>
                            <button class="btn-primer" type="submit">
                                <div v-show="loading == false">Selanjutnya</div>
                                <Loader class="loading" v-show="loading" />
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import Loader from "../assets/Loading";
import HeadRegister from "./component/HeadRegister.vue";

export default {
    components: {
        Loader,
        HeadRegister,
    },
    data() {
        return {
            checkedStatement: "",
            selected: "",
            gajiPerbulan: [],
            sumberdana: [],
            loading: false,
            transaksiPerbulan: "",
            tujuanBukaRekening: "",
            purpose_open_type: "",
            idFinancial: "",
            njop_value: "",
            total_deposit: "",
            form: {
                fund_code: "",
                salary_code: "",
                monthly_transaction_code: "",
                purpose_fund_code: "",
                wealth_list: {
                    home_location: "",
                    njop_value: "",
                    deposit: "",
                    total_deposit: "",
                    other: "",
                },
                has_confirm_financial: false,
                step: "finance",
            },
        };
    },
    mounted() {
        axios.get("/v2/master_data/monthly_transaction").then((res) => {
            this.transaksiPerbulan = res.data.data;
        });

        axios.get("/v2/master_data/salary").then((res) => {
            this.gajiPerbulan = res.data.data;
        });

        axios.get("/v2/master_data/fund").then((res) => {
            this.sumberdana = res.data.data;
        });

        //Get tujuan penggunaan rekening
        axios.get("/v2/master_data/purpose_fund").then((res) => {
            this.tujuanBukaRekening = res.data.data;
        });

        //Get tujuan pembukaan rekening
        axios.get("/v2/master_data/purpose_open_account").then((res) => {
            this.purpose_open_type = res.data.data;
        });

        this.$store.dispatch("getCustomer").then((response) => {
            this.idFinancial = response._id;
            axios.get("/v2/kyc/financial/" + this.idFinancial).then((res) => {
                let financial = res.data.data.financial;
                this.form.has_confirm_financial = financial.has_confirm_financial;
                this.form.wealth_list.home_location = financial.wealth_list.home_location;
                this.form.wealth_list.njop_value = financial.wealth_list.njop_value;
                this.form.wealth_list.deposit = financial.wealth_list.deposit;
                this.form.wealth_list.total_deposit = financial.wealth_list.total_deposit;
                this.form.wealth_list.other = financial.wealth_list.other;
                this.form.salary_code = financial.salary_type.code;
                this.form.fund_code = financial.fund_type.code;
                this.form.monthly_transaction_code = financial.monthly_transaction_type.code;
                this.form.purpose_fund_code = financial.purpose_fund_type.code;
                this.form.purpose_open_account_code = financial.purpose_open_account_type.code;
                this.form.has_investment_experience = financial.has_investment_experience;
                this.form.investment_experience = financial.investment_experience;
            });
        });
    },
    computed: {
        customerId() {
            return this.$store.getters.customerData._id;
        },
    },
    watch: {
        "form.wealth_list.total_deposit"() {
            this.form.wealth_list.total_deposit = this.currencyFormat(this.form.wealth_list.total_deposit);
        },
        "form.wealth_list.njop_value"() {
            this.form.wealth_list.njop_value = this.currencyFormat(this.form.wealth_list.njop_value);
        },
    },
    methods: {
        currencyFormat(value) {
            return (value + "").replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        },
        formatNumber(value) {
            return value.replace(/[^\d]/g, "");
        },
        formatRupiah(angka, prefix) {
            var number_string = angka.replace(/[^,\d]/g, "").toString(),
                split = number_string.split(","),
                sisa = split[0].length % 3,
                rupiah = split[0].substr(0, sisa),
                ribuan = split[0].substr(sisa).match(/\d{3}/gi);
            let separator;

            // tambahkan titik jika yang di input sudah menjadi angka ribuan
            if (ribuan) {
                separator = sisa ? "." : "";
                rupiah += separator + ribuan.join(".");
            }

            rupiah = split[1] != undefined ? rupiah + "," + split[1] : rupiah;
            return prefix == undefined ? rupiah : rupiah ? "Rp. " + rupiah : "";
        },
        avaregeMount() {
            this.form.monthly_transaction = this.monthly_transaction.nama;
            this.form.average_type = this.monthly_transaction.id;
        },
        selectSourceOfFund() {
            this.form.source_of_funds = this.source_of_funds.nama;
            this.form.fund_type = this.source_of_funds.id;
        },
        sourceOfFundPerYear() {
            this.form.renumerasi_type = this.avg_income_year.id;
            this.form.avg_income_year = this.avg_income_year.nama;
        },
        purposeFund() {
            this.form.purpose_fund_type = this.fund_objectives.id;
            this.form.fund_objectives = this.fund_objectives.value;
        },
        toggleModal() {
            this.$refs["my-modal"].toggle("#toggle-btn");
        },
        registerKYC() {
            this.loading = true;

            let data = {
                fund_code: this.form.fund_code,
                salary_code: this.form.salary_code,
                monthly_transaction_code: this.form.monthly_transaction_code,
                purpose_fund_code: this.form.purpose_fund_code,
                wealth_list: {
                    home_location: this.form.wealth_list.home_location,
                    njop_value: this.formatNumber(this.form.wealth_list.njop_value),
                    deposit: this.form.wealth_list.deposit,
                    total_deposit: this.formatNumber(this.form.wealth_list.total_deposit),
                    other: this.form.wealth_list.other,
                },
                has_confirm_financial: this.form.has_confirm_financial,
            };

            axios
                .put("/v2/kyc/financial/" + this.customerId, data)
                .then((res) => {
                    let status = res.data.data.status_code;
                    if (status == "00") {
                        this.$router.push("/register-datarekening");
                    } else if (status == "2004") {
                        this.loading = false;
                        this.$notify({
                            group: "foo",
                            title: "<h5>Data sudah di submit</h5>",
                            type: "error",
                            duration: 2000,
                        });
                    } else {
                        this.loading = false;
                        this.$notify({
                            group: "foo",
                            title: "<h5>kesalahan sistem</h5>",
                            type: "error",
                            duration: 2000,
                        });
                    }
                })
                .catch(() => {
                    this.loading = false;
                    this.$notify({
                        group: "foo",
                        title: "<h5>Cek kembali inputan anda</h5>",
                        type: "error",
                        duration: 2000,
                    });
                });
        },
        isNumber(event) {
            const pattern = /[0-9]/;
            let inputChar = String.fromCharCode(event.charCode);
            if (event.keyCode != 8 && !pattern.test(inputChar)) {
                event.preventDefault();
            }
        },
    },
};
</script>

<style scoped>
.container-outline {
    width: 70%;
}

.deactive {
    display: none;
}

.pengalamanActive {
    display: block;
}

.sub {
    font-weight: bold;
    margin: 20px 0;
    font-size: 17px;
}

.li-active:nth-child(4)::before {
    border: dashed 1px #c59733;
}

.form-checkbox {
    margin-top: 50px;
    font-size: 14px;
    color: #707070;
    display: flex;
}

.label-radio {
    width: 185px;
    cursor: pointer;
}

.outer {
    margin: 10px 25px 10px 15px;
}

.register {
    margin: 46px 0;
}

label {
    font-size: 14px;
    width: 205px;
    display: inline-block;
}

.detail-alamat {
    width: 175px;
    margin: 0 0 0 30px;
}

.form-input {
    width: 73%;
    text-transform: capitalize;
}

.other-choice {
    margin-top: 15px;
}

select {
    width: 73%;
    height: 45px;
}

.tempat {
    width: 41%;
    margin: 0 25px 0 0;
}

.tanggal {
    width: 25%;
    border-bottom-right-radius: 0;
    border-top-right-radius: 0;
}

.pos-telepon {
    width: 25%;
}

.rupiah {
    width: 7%;
    margin: 0 30px 0 0;
}

.nilai-rupiah {
    width: 62%;
}

.reason {
    height: 99px;
    resize: none;
    vertical-align: top;
    padding: 20px;
    font-size: 14px;
    font-family: "Poppins", sans-serif;
}

.reason:focus {
    color: #495057;
    background-color: #fff;
    border-color: #6454f0 !important;
    outline: 0;
    z-index: 3;
    box-shadow: 0 0 0 0.3rem rgba(100, 84, 240, 0.25);
}

.tahun {
    margin: 0 0 0 30px;
}

.penghasilan-bulan {
    width: 25%;
    margin: 0 32px 0 0;
    background-position-x: 88%;
}

.penghasilan-nilai {
    width: 44%;
    background-position-x: 94.4%;
}

.no-identitas {
    width: 50%;
}

.input-button {
    width: 50px;
    height: 50px;
    text-align: center;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    position: relative;
    top: 6px;
    left: -1px;
    border: solid 1px #707070;
    background-color: #6454f0;
    border-bottom-right-radius: 10px;
    border-top-right-radius: 10px;
}

.icon-calender {
    font-size: 20px;
    color: white;
}

.content-register {
    box-shadow: 0 0 2rem 0 rgba(136, 152, 170, 0.15);
    background: #ffffff;
    border-radius: 5px;
}

.title {
    font-size: 25px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    margin: 0 0 50px;
}

.navigation {
    margin: 0 0 50px;
    font-size: 10px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
}
.container {
    width: 90%;
    padding-top: 45px;
}

.nav-root {
    display: flex;
    justify-content: space-between;
    margin: 0 0 50px;
    position: relative;
}

.list-root {
    list-style: none;
    height: 65px;
    width: 40%;
    padding: 20px 15px;
    text-align: center;
    color: rgba(112, 112, 112, 0.5);
}

.active {
    border-top-right-radius: 30px;
    border-bottom-right-radius: 30px;
    border-top: solid 2px #000e22;
    border-right: solid 2px #000e22;
    border-bottom: solid 2px #000e22;
    background-color: #1f354a;
    color: white;
    position: relative;
    text-align: center;
}

.active:first-child {
    border-top-left-radius: 15px;
}

.active:last-child {
    border-top-right-radius: 15px;
    border-bottom-right-radius: 0;
}

.active::before {
    z-index: -1;
    position: absolute;
    content: "";
    display: inline-block;
    width: 50px;
    height: 65px;
    background-color: #1f354a;
    top: -2px;
    left: -41px;
    border: 2px solid #000e22;
}

.active:first-child::before {
    opacity: 0;
}

.button {
    display: flex;
    justify-content: space-between;
    padding: 76px 15px;
}

h3 {
    margin: 30px 0;
}

.sub-title {
    margin: 0 0 73px;
    font-size: 18px;
    font-weight: bold;
}

.arrow {
    margin-left: 10px;
    margin-right: 10px;
    border: solid #6454f0;
    border-width: 0 3px 3px 0;
    display: inline-block;
    padding: 4px;
    transform: rotate(45deg);
    vertical-align: super;
}

.wrap-arrow {
    position: absolute;
    display: inline-block;
    width: 56px;
    height: 48px;
    /* border: solid 1px; */
    right: 50px;
    top: 1px;
    border-radius: 10px;
    text-align: center;
    padding: 15px 9px;
    background: white;
}

@media (min-width: 768px) and (max-width: 1023px) {
    .list-root {
        font-size: 13px;
    }
    .active {
        padding: 10px;
        text-align: center;
        font-size: 13px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .active::before {
        width: 28px;
        left: -25px;
    }

    label,
    select,
    .form-input,
    .detail-alamat {
        width: 100%;
    }

    .penghasilan-bulan {
        width: 20%;
    }

    .penghasilan-nilai {
        width: 74%;
    }

    .rupiah {
        width: 15%;
        margin-left: 30px;
    }

    .address,
    .pos-telepon {
        margin-left: 30px;
        width: 95%;
    }

    .nilai-rupiah {
        width: 74%;
    }
}

@media (max-width: 768px) {
    .container-outline {
        width: 90%;
    }

    li > span {
        display: none;
    }

    .form-input,
    select,
    .input-button {
        width: 100%;
    }

    label {
        display: block;
    }

    .birtday,
    .kecamatan,
    .input-rt-rw {
        width: 100% !important;
        text-align: left;
    }

    .register {
        margin: 20px 0;
    }

    .title {
        font-size: 18px;
        margin: 0 0 20px;
    }

    .sub-title {
        margin-bottom: 20px;
    }

    .top-squence {
        width: 100%;
        padding: 15px 10px;
    }

    .container {
        width: 100%;
        padding: 25px 20px;
    }

    .identitas,
    .form-ktp-bagi,
    .tanggal-aktif,
    .tempat,
    .kecamatan,
    .input-rt-rw {
        margin: 0 0 10px;
    }

    .detail-alamat,
    .rt-rw {
        margin: 0 0 0.5rem;
    }

    .form-checkbox {
        align-items: flex-start;
    }

    .label--checkbox {
        margin-left: 15px;
    }

    .button {
        display: block;
        width: 100%;
        text-align: center;
    }

    .btn-scondary,
    .btn-primer {
        width: 100%;
    }

    .btn-scondary {
        margin-bottom: 20px;
    }

    .rupiah {
        width: 20%;
        margin-right: 20px;
    }

    .nilai-rupiah {
        width: 73%;
    }
}
</style>
